/** @format */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//importing components
import DynamicTable from "../../components/global/DynamicTable";
//import components
import HeadTitle from "../../components/global/HeadTitle";

//import table data
import { tableColumnGuarantor } from "../../components/table/col-data";
import { getAllClients } from "../../services/clintServices";
import Table from "../../components/Table2";
import { Spinner1 } from "../../components/spinners/Spinner1";
import { clientColumn } from "../../constant/table";
import FilterComponent from "../../components/FilterComponent";
import Pagination from "../../components/Pagination";
import { deleteCategoryRTK } from "../../store/category";
import NavbarAndSidebar from "../../components/NavbarAndSidebar";

const Guarantor = () => {
  const [searchValues, setSearch] = useState({});
  const dispatch = useDispatch();
  const { allClients, loading } = useSelector((state) => state.clientSlice);

  useEffect(() => {
    dispatch(getAllClients("/clients?page=1"));
  }, []);

  const getSearchValue = (value, labelName, stateName) => {
    let searchValuesClone = { ...searchValues };
    searchValuesClone = {
      ...searchValuesClone,
      [stateName]: { label: labelName, value: value },
    };
    setSearch(searchValuesClone);
    prepareSearchValuesForAPIs(searchValuesClone);
  };
  const deleteSearch = (stateName) => {
    let searchValuesClone = { ...searchValues };
    delete searchValuesClone[stateName];
    setSearch(searchValuesClone);
    prepareSearchValuesForAPIs(searchValuesClone);
  };
  const prepareSearchValuesForAPIs = (searchValuesClone) => {
    let searchString = "";
    Object.keys(searchValuesClone).forEach((item) => {
      searchString = searchString + item + "=" + searchValuesClone[item].value;
    });
    dispatch(getAllClients(`/clients?${searchString}`));
  };
  const getPageData = (num) => {
    dispatch(getAllClients("/clients" + "?page=" + num));
  };
  return (
    <NavbarAndSidebar>
      <HeadTitle title='الكفيل' />
      <div className='mb__small' />
      {!!Object.keys(searchValues).length && (
        <FilterComponent filters={searchValues} deleteSearch={deleteSearch} />
      )}

      <Table
        data={allClients?.data}
        header={clientColumn}
        link='/guarantor/'
        getSearchValue={getSearchValue}
        searchValues={searchValues}
        name='clients'
      />
      {loading && <Spinner1 />}

      {allClients?.pagination?.totalPages > 1 ? (
        <Pagination
          pagination={allClients?.pagination}
          getPageData={getPageData}
        />
      ) : null}
    </NavbarAndSidebar>
  );
};
export default Guarantor;
